import SendRfq from './SendRfq';

export default SendRfq;



// WEBPACK FOOTER //
// ./src/components/Modals/SendRfq/index.jsx